import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import uniqid from 'uniqid';

import { api_crud_base, api_crud_route, api_list_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
import { icon } from '../../../WEBContent/Icon';
import { color } from '../../../WEBContent/Color';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	translate,
	functionSendMail,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';
import { set } from 'core-js/core/dict';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const entities_list = useRef(null);
	const entities_list_external = useRef(null);
	const active = useRef(null);
	const active_raw = useRef(null);
	const repair_type = useRef(null);
	const periodicity = useRef(null);
	const priority = useRef(null);
	const maintenance_intervention = useRef(null);
	const maintenance_orders = useRef(null);
	
	const year_active = useRef(null);
	const years_actives = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [uid,] = useState(uniqid());

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)
	const [treeDataPDF, setTreeDataPDF] = useState([])
	const [treeDataEditable, setTreeDataEditable] = useState([])

	const [files_doc_pdf, set_files_doc_pdf] = useState([]);
	const [files_doc_pdf_name, set_files_doc_pdf_name] = useState([]);
	const [files_doc_editable, set_files_doc_editable] = useState([]);
	const [files_doc_editable_name, set_files_doc_editable_name] = useState([]);

	const [treeDataImage, setTreeDataImage] = useState([])
	const [files_doc_image, set_files_doc_image] = useState([]);
	const [files_doc_image_name, set_files_doc_image_name] = useState([]);

	const [notify_responsable_edit, set_notify_responsable_edit] = useState(false)
	const [notify_responsable_aproval, set_notify_responsable_aproval] = useState(false)
	const [notify_responsable_remove, set_notify_responsable_remove] = useState(false)

	const [document_state_list, set_document_state_list] = useState([])
	const [document_state_aprove, set_document_state_aprove] = useState(false)

	const [selectedEquipment, setSelectedEquipment] = useState(null);
	const [manutencao, setManutencao] = useState(null); //TRUE = 'Manutenção', FALSE = 'Reparação', NULL = 'Nenhum'
	const [externalIntervention, setExternalIntervention] = useState('');

	const [modal, setModal] = useState(false);
	const [update, setUpdate] = useState(0);
	const [isEditing, setIsEditing] = useState(false);
	const [editItemId, setEditItemId] = useState(null);
	const [filterYear, setFilterYear] = useState(new Date().getFullYear().toString());
	const [filterMonth, setFilterMonth] = useState('');

	const tableStyle = {
		borderCollapse: 'collapse',
		color: color.cor1.hexa,
		textAlign: 'left',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
		borderRadius: '8px',
		overflow: 'hidden',
		backgroundColor: color.cor3.hexa,
	};

	const headerCellStyle = {
		padding: '12px 15px',
		textAlign: 'center',
		color: color.cor3.hexa,
		fontWeight: '600',
		borderBottom: '2px solid #ddd',
		backgroundColor: color.corPrimaria.rgb,
		textTransform: 'uppercase',
	};

	const cellStyle = {
		borderBottom: `1px solid rgb(${color.cor3.rgb})`,
		textAlign: 'center',
		verticalAlign: 'middle',
		padding: '12px 15px',
		color: color.corCinza.hexa,
		lineHeight: '1.6',
		backgroundColor: color.cor3.hexa,
	};

	const rowStyle = {
		fontSize: '14px',
		backgroundColor: color.cor3.hexa,
		transition: 'background-color 0.3s ease',
	};

	const filterContainerStyle = {
		display: 'flex',
		gap: '12px',
		marginBottom: '20px',
		flexWrap: 'wrap',
		alignItems: 'flex-end',
	};

	const filterItemStyle = {
		flex: '1 1 160px',
		display: 'flex',
		flexDirection: 'column',
	};

	const filterLabelStyle = {
		marginBottom: '4px',
		color: color.cor1.hexa,
		fontWeight: '500',
	};

	const filterSelectStyle = {
		padding: '6px 10px',
		border: `1px solid ${color.corCinza.hexa}`,
		borderRadius: '4px',
		backgroundColor: color.cor3.hexa,
		color: color.cor1.hexa,
	};

	const MONTH_NAMES = [
		language[lang].janeiro,
		language[lang].fevereiro,
		language[lang].marco,
		language[lang].abril,
		language[lang].maio,
		language[lang].junho,
		language[lang].julho,
		language[lang].agosto,
		language[lang].setembro,
		language[lang].outubro,
		language[lang].novembro,
		language[lang].dezembro
	];

	const selectedMonthName = filterMonth ? MONTH_NAMES[parseInt(filterMonth) - 1] : '';

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset;

		if (dados.current[name] === undefined) {
			dados.current[name] = [];
		}

		let value_aux = {};
		let aux = dados.current[name].filter(e => e[lang]);
		if (aux !== undefined && aux.length === 0) {
			value_aux[lang] = value;
			dados.current[name].push(value_aux);
		} else {
			dados.current[name].forEach(el => {
				if (el[lang] !== undefined) {
					el[lang] = value;
				}
			});
		}

		if (name === 'title' && parseInt(langid) === 1) {
			dados.current.name = value;
		}

		set_dados({ ...dados.current });
	};

	const change_active_settings = (e) => {
		const { name, value } = e.target;

		if (!dados.current.info) {
			dados.current.info = {};
		}

		if (!dados.current.info.settings) {
			dados.current.info.settings = {};
		}

		dados.current.info.settings[name] = value;
		set_dados({ ...dados.current });

		const parsedValue = parseInt(value, 10);
		if (parsedValue === 13) {
			setManutencao(true);
		} else if (parsedValue === 12) {
			setManutencao(false);
		}
	};

	// ---------------------- ACTION ----------------------

	const add_action = () => {
		const info = dados.current.info;
		if (!Array.isArray(info.action)) {
			info.action = [];
		}
		info.action.push({});
		set_dados({ ...dados.current });
	};

	const change_action = (e) => {
		const { name, value, dataset } = e.target;
		const order = parseInt(dataset.order);
		const info = dados.current.info;

		if (!Array.isArray(info.action)) {
			info.action = [];
		}

		if (!info.action[order]) {
			info.action[order] = {};
		}

		if (name === 'responsavel') {
			const aux_entity = entities_list.current?.filter(el => parseInt(el.id) === parseInt(value));
			let aux = {
				id: value,
				name: '',
				notification: '',
				execution: ''
			};
			if (Array.isArray(aux_entity) && aux_entity.length > 0) {
				aux.name = aux_entity[0].label;
			}
			info.action[order][name] = aux;
		} else {
			info.action[order][name] = value;
		}

		set_dados({ ...dados.current });
		setRefresh(r => r + 1);
	};

	// ---------------------- UTILITIES ----------------------

	const add_utilities = () => {
		const info = dados.current.info;
		if (!Array.isArray(info.utilities)) {
			info.utilities = [];
		}
		info.utilities.push({});
		set_dados({ ...dados.current });
	};

	const change_utilities = (e) => {
		const { name, value, dataset, options, selectedIndex } = e.target;
		const order = parseInt(dataset.order);
		const info = dados.current.info;

		if (!Array.isArray(info.utilities)) {
			info.utilities = [];
		}

		if (!info.utilities[order]) {
			info.utilities[order] = {};
		}

		if (name === 'fornecedor') {
			const selectedOption = options[selectedIndex];
			let aux = {
				id: value,
				name: selectedOption.dataset.name || '',
				notification: '',
				execution: ''
			};
			info.utilities[order][name] = aux;
		} else {
			info.utilities[order][name] = value;
		}

		set_dados({ ...dados.current });
		setRefresh(r => r + 1);
	};

	// ---------------------- SERVICE ----------------------

	const add_service = () => {
		const info = dados.current.info;
		if (!Array.isArray(info.service)) {
			info.service = [];
		}
		info.service.push({});
		set_dados({ ...dados.current });
	};

	const change_service = (e) => {
		const { name, value, dataset, options, selectedIndex } = e.target;
		const order = parseInt(dataset.order);
		const info = dados.current.info;

		if (!Array.isArray(info.service)) {
			info.service = [];
		}

		if (!info.service[order]) {
			info.service[order] = {};
		}

		if (name === 'fornecedor') {
			const selectedOption = options[selectedIndex];
			let aux = {
				id: value,
				name: selectedOption.dataset.name || '',
				notification: '',
				execution: ''
			};
			info.service[order][name] = aux;
		} else {
			info.service[order][name] = value;
		}

		set_dados({ ...dados.current });
		setRefresh(r => r + 1);
	};


	////////////////////////////////////////////////////////////////////////////////////////


	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const fetch_entities_list = async (type) => {

		let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
		let result = []

		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.entity_type) === parseInt(type))
		}

		return result

	}

	const fetch_maintenance_actives = async (type) => {

		let res = await reqGET(`${api_crud_base}/intranet/maintenance/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {
				//console.log('el', el)
				let aux = {
					id: el.id,
					name: translate(el.info.title, 'pt'),

					cod: el.info.tag,
					brand: el.info.settings.storage_brand,
					model: el.info.settings.storage_model,
					serie: el.info.settings.storage_serie,
					local: el.info.settings.storage_local,
				}

				result.push(aux)
			}
		}

		return result

	}

	const get_info = async (id_eq) => {
		await reqGET(api_list_route(getTokenInfo().companycode))
			.then(async res => {
				if (res.data[0] !== undefined) {

					if(Array.isArray(res.data) && res.data.length > 0) {

						let array_aux = []
						let array_ano_aux = []
						for await (let el of res.data) {

							if (parseInt(el.info.equipment.id) === parseInt(id_eq)) {
								array_aux.push(el)

								if(el?.info?.settings?.data_intervencao !== undefined && el?.info?.settings?.data_intervencao !== null && el.info.settings.data_intervencao !== '') {
									let aux_data = el.info.settings.data_intervencao.split('-')
									let aux_2 = array_ano_aux.filter(e1 => parseInt(e1) === parseInt(aux_data[0]))
									if(Array.isArray(aux_2) && aux_2.length === 0) {
										array_ano_aux.push(aux_data[0])
									}
								}
							}

						}

						set_dados(maintenance_intervention.current = array_aux);
						set_dados(years_actives.current = array_ano_aux)
						set_dados(year_active.current = years_actives.current[0])
					
					}

					// set_maintenance_intervention(res.data);
					// set_dados(maintenance_intervention.current = res.data);

					//console.log('maintenance_intervention.current', maintenance_intervention.current)

				}


			})
			.catch(() => 404
			)
	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	useEffect(() => {
		clean_data();

		const currentYear = new Date().getFullYear();
		setFilterYear(String(currentYear));

		set_lang(localStorage.getItem('lang'))

		set_dados(entities_list.current = [])
		set_dados(active.current = [])

		let aux_document_state = [
			{
				id: 0,
				label: 'Em edição'
			},
			{
				id: 1,
				label: 'Aguarda aprovação'
			},
			{
				id: 2,
				label: 'Em revisão'
			},
			{
				id: 3,
				label: 'Aprovado'
			},
			{
				id: 4,
				label: 'Obsoleto'
			},
			{
				id: 5,
				label: 'Eliminado'
			}
		]
		set_document_state_list(aux_document_state)

		const fetch_maintenance_attributes = async (type) => {

			let res = await reqGET(`${api_crud_base}/intranet/maintenance/attribute/type/${getTokenInfo().companycode}/${type}`)
			let result = []
			if (res.data !== undefined) {
				for await (let el of res.data) {

					let aux = {
						id: el.id,
						name: translate(el.info.title, 'pt')
					}

					result.push(aux)
				}
			}

			return result

		}

		const get_attr = async () => {		

			let res_1 = await fetch_maintenance_actives('active')
			if (res_1.length > 0) {
				res_1 = order_array(res_1)

				let res_aux_1 = []
				for await (let el of res_1) {
					res_aux_1.push({
						id: el.id,
						label: el.name,
						cod: el.cod,
					})
				}
				set_dados(active.current = res_aux_1)
				set_dados(active_raw.current = res_1)

				if (dados.current.info?.equipment?.id !== undefined && dados.current.info.equipment.id !== null && dados.current.info.equipment.id !== '') {
					const selected = res_1?.find(el => parseInt(el.id) === parseInt(dados.current.info.equipment.id))
					setSelectedEquipment(selected || null);
				}
			}

			let res_2 = await fetch_maintenance_attributes('repair_type')
			if (res_2.length > 0) {
				res_2 = order_array(res_2)

				let res_aux_2 = []
				for await (let el of res_2) {
					res_aux_2.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(repair_type.current = res_aux_2)
			}

			let res_3 = await fetch_maintenance_attributes('periodicity')
			if (res_3.length > 0) {
				res_3 = order_array(res_3)

				let res_aux_3 = []
				for await (let el of res_3) {
					res_aux_3.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(periodicity.current = res_aux_3)
			}

			let res_4 = await fetch_entities_list(1)
			if (res_4.length > 0) {
				res_4 = order_array(res_4)

				let res_aux_4 = []
				for await (let el of res_4) {
					res_aux_4.push({
						id: el.id,
						label: el.name,
						email: el.email
					})
				}
				set_dados(entities_list.current = res_aux_4)
			}

			let res_5 = await fetch_maintenance_attributes('priority')
			if (res_5.length > 0) {
				res_5 = order_array(res_5)

				let res_aux_5 = []
				for await (let el of res_5) {
					res_aux_5.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(priority.current = res_aux_5)
			}

			let res_6 = await fetch_entities_list(2);
			if (res_6.length > 0) {
				res_6 = order_array(res_6);

				let res_aux_6 = [];
				for await (let el of res_6) {
					if (parseInt(el.relacao) === 10) {
						res_aux_6.push({ ...el });
					}
				}

				set_dados(entities_list_external.current = res_aux_6);
			}

			//let res_7 = await fetch_maintenance_attributes('orders')
			let res_7 = await reqGET(`${api_crud_base}/intranet/maintenance/type/${getTokenInfo().companycode}/orders`);
			if (res_7.length > 0) {
				res_7 = order_array(res_7)

				let res_aux_7 = []
				for await (let el of res_7) {
					res_aux_7.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(maintenance_orders.current = res_aux_7)
			}			

			setLoading(false);

			return true

		}

		const fetch_id_info = async (id_serch) => {

			await get_attr()

			try {

				let res = await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
				set_dados(dados.current = res.data[0]);

				if (Array.isArray(res.data) && res.data.length > 0) {
					if (res.data[0]?.info?.file?.pdf !== undefined && Array.isArray(res.data[0].info.file.pdf)) {
						let aux_doc_pdf = []
						let i = 0

						for await (let el of res.data[0].info.file.pdf) {
							if (aux_doc_pdf[0] === undefined)
								aux_doc_pdf[0] = []
							if (aux_doc_pdf[0][1] === undefined)
								aux_doc_pdf[0][1] = []

							// aux_doc_pdf[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDF(aux_doc_pdf)
					}
					if (res.data[0]?.info?.file?.editable !== undefined && Array.isArray(res.data[0].info.file.editable)) {
						let aux_doc_editable = []
						let i = 0

						for await (let el of res.data[0].info.file.editable) {
							if (aux_doc_editable[0] === undefined)
								aux_doc_editable[0] = []
							if (aux_doc_editable[0][1] === undefined)
								aux_doc_editable[0][1] = []

							// aux_doc_editable[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_editable[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataEditable(aux_doc_editable)
					}
					if (res.data[0]?.info?.file?.file_image !== undefined && Array.isArray(res.data[0].info.file.file_image)) {
						let aux_doc_image = []
						let i = 0

						for await (let el of res.data[0].info.file.file_image) {
							if (aux_doc_image[0] === undefined)
								aux_doc_image[0] = []
							if (aux_doc_image[0][1] === undefined)
								aux_doc_image[0][1] = []

							aux_doc_image[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							// aux_doc_image[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataImage(aux_doc_image)
					}

					const equipment = res.data[0].info?.equipment || '';

					if (equipment?.id != null && equipment.id !== '') {
						const selected = active_raw.current?.find(
							el => parseInt(el.id) === parseInt(equipment.id)
						);
						setSelectedEquipment(selected || null);
					}

					/*
					if (res.data[0] !== undefined && res.data[0] !== null && res.data[0] !== '') {
						const selected = active_raw.current?.find(el => parseInt(el.id) === parseInt(res.data[0].id))
						setSelectedEquipment(selected || null);

					}
					*/
				}

				set_is_edit(true)

				get_info(id_serch)

			} catch (error) {
				console.error("Erro:", error);
			}
		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				fetch_id_info(props.location.state.item.id)
			}
			else {
				get_attr()
			}

		} catch {
			clean_data()

			get_attr()

			return
		}

	}, [props, active_raw]);

	const handleSubmit = async e => {
		e.preventDefault();

		let today = new Date();
		let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();


		if (is_edit === true) {

			await Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						if (document_state_aprove) {
							dados.current.info.settings.document_state = "3"

							dados.current.info.responsable.aproval.execution = today
							dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today
						}

						if (notify_responsable_edit) {
							if (dados.current.info.responsable.edit.id !== '') {
								let aux_id = dados.current.info.responsable.edit.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.edit.notification = today
								dados.current.info.responsable.edit.execution = today

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})

									dados.current.info.responsable.aproval.id = ''
									dados.current.info.responsable.aproval.name = ''
									dados.current.info.responsable.aproval.notification = ''
									dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
									}
									else {
										dados.current.info.historic.push({
											edit: {
												id: aux_responsable[0].id,
												name: aux_responsable[0].label,
												date: today
											},
											aproval: {
												id: '',
												name: '',
												date: ''
											}
										})

										dados.current.info.settings.document_state = "1"

										dados.current.info.responsable.aproval.id = ''
										dados.current.info.responsable.aproval.name = ''
										dados.current.info.responsable.aproval.notification = ''
										dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.aproval.notification = today

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados.current.info.responsable.remove.id !== '') {

								dados.current.info.responsable.remove.notification = today
								dados.current.info.responsable.remove.execution = today

							}

						}

						await reqPUT(api_crud_route, maintenance_intervention.current)
							.then(async () => {
								if (notify_responsable_edit) {

								}
								if (notify_responsable_aproval) {
									if (dados.current.info.responsable.aproval.id !== '') {

										let aux_id = dados.current.info.responsable.aproval.id
										let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										if (Array.isArray(aux_responsable) && aux_responsable.length > 0) {

											let aux = {
												id: dados.current.id,
												uniqid: dados.current.info.uniqid,
												companycode: dados.current.info.companycode,

												type: 'maintenance',
												title: translate(dados.current.info.title, lang),
												description: translate(dados.current.info.description, lang),
												responsaveis: [{
													value: aux_responsable[0].id
												}],
												state_object: {
													value: 1,
													labelEn: "Pending approval",
													labelPt: "Pendente de aprovação"
												},
												deadline: '',
											}

											reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

											return

											let mail_content = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + '; border:1px solid transparent; border-collapse:collapse;">' +
												'<tr style="border-collapse: collapse;">' +
												'<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span><b>' + language[lang].notification_aproval_subject + '</b></span>' +
												'</div>' +
												'</td>' +
												'<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span>' + today_aux + '</span>' +
												'</div>' +
												'</td>' +
												'</tr>' +

												'<tr>' +
												'<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
												'</tr>' +

												'<tr style="border-collapse: collapse;">' +
												'<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<br/>' +
												'<span>' + language[lang].notification_aproval_text + '</span>' +
												'<br/>' +
												'</div>' +
												'</td>' +
												'</tr>' +
												'</table>'

											// let sendFrom = 'web.dev@assec.pt'
											// let sendTo = ['web.teste@assec.pt']
											// let sendToCC = ['web.dev@assec.pt']
											// let subject = language[lang].notification_aproval_subject
											// let content = mail_content
											// let attachment = []

											// await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)
										}

									}
								}
								if (notify_responsable_remove) {
									if (dados.current.info.responsable.remove.id !== '') {
										// let aux_id = dados.current.info.responsable.remove.id
										// let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										// console.log('remove aux_responsable', aux_responsable)
										dados.current.info.responsable.remove.notification = today
									}
								}

							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		}
		else {

			await Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						dados.current.info['uniqid'] = uid

						if (notify_responsable_edit) {
							if (dados.current.info.responsable.edit.id !== '') {
								let aux_id = dados.current.info.responsable.edit.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.edit.notification = today
								dados.current.info.responsable.edit.execution = today

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})

									// dados.current.info.responsable.aproval.id = ''
									// dados.current.info.responsable.aproval.name = ''
									// dados.current.info.responsable.aproval.notification = ''
									// dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
									}
									else {
										dados.current.info.historic.push({
											edit: {
												id: aux_responsable[0].id,
												name: aux_responsable[0].label,
												date: today
											},
											aproval: {
												id: '',
												name: '',
												date: ''
											}
										})

										dados.current.info.settings.document_state = "1"

										// dados.current.info.responsable.aproval.id = ''
										// dados.current.info.responsable.aproval.name = ''
										// dados.current.info.responsable.aproval.notification = ''
										// dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.aproval.notification = today

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados.current.info.responsable.remove.id !== '') {

								dados.current.info.responsable.remove.notification = today
								dados.current.info.responsable.remove.execution = today

							}

						}

						for await (let el_doc of files_doc_pdf) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf([])
						set_files_doc_pdf_name([])

						for await (let el_doc of files_doc_editable) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_editable([])
						set_files_doc_editable_name([])

						for await (let el_doc of files_doc_image) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'file_image', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_image([])
						set_files_doc_image_name([])

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}

		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route, { id: dados.current.id })
						.then(() => {
							props.history.push(endpoints.list);
						})
						.catch(error => console.log(error))
				}
			})
			.catch((erro) => {
				console.log(erro)
			})

	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang } = dataset

		if (name === 'name' && 0) {
			let value_aux = {}
			let aux = dados.current.info.name.filter(e => e[lang])
			if (aux !== undefined && aux.length === 0) {
				value_aux[lang] = value
				dados.current.info.name.push(value_aux)
			}
			else {
				dados.current.info.name.forEach(el => {
					if (el[lang] !== undefined) {
						el[lang] = value
					}
				})
			}
		}

		if (name === 'external_intervention') {
			setExternalIntervention(value);
		}

		dados.current.info[name] = value
	}

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvaiable = () => {
		set_dados(dados.current.info.avaiable = !dados.current.info.avaiable)
	}

	const handleSingleCheckAproval = () => {

		set_document_state_aprove(!document_state_aprove)

	}

	const change_active_responsable = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.responsable === undefined) {
			dados.current.info.responsable = {}
		}

		if (name === 'edit') {
			set_notify_responsable_edit(true)
		}
		else if (name === 'aproval') {
			set_notify_responsable_aproval(true)
		}
		else if (name === 'remove') {
			set_notify_responsable_remove(true)
		}

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: value,
			name: '',
			notification: '',
			execution: ''
		}
		if (Array.isArray(aux_entity) && aux_entity.length > 0) {
			aux.name = aux_entity[0].label
		}

		set_dados(dados.current.info.responsable[name] = aux)

	}

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const handle_change_tree_editable = (tD, order, langid) => {

		treeDataEditable[order][langid] = tD

		let aux = []
		treeDataEditable[order][langid].forEach((el) => {
			dados.current.info.file.editable.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.editable = aux)
		setTreeDataEditable(treeDataEditable)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_editable = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataEditable[order][langid].filter(v => v.id !== id)
					treeDataEditable[order][langid] = treeAux
					setTreeDataEditable(treeDataEditable)

					let aux = []
					dados.current.info.file.editable.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.editable = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_editable = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataEditable[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.editable.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataEditable(treeDataEditable)
		set_dados(dados.current.info,)
	}

	const onChangeHandlerFilesEditable = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_editable_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_editable_name(aux2)

				let aux_doc = treeDataEditable
				if (treeDataEditable[order] === undefined)
					treeDataEditable[order] = []
				if (treeDataEditable[order][langid] === undefined)
					treeDataEditable[order][langid] = []
				let i = treeDataEditable[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataEditable(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_editable
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_editable(files_aux)
	}

	const handle_change_tree_pdf = (tD, order, langid) => {

		treeDataPDF[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}
		else {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDF[order][langid].filter(v => v.id !== id)
					treeDataPDF[order][langid] = treeAux
					setTreeDataPDF(treeDataPDF)

					let aux = []
					if (langid === '1') {
						dados.current.content[order].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order].media.doc = aux)
					}
					else {
						dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
					}

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDF[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDF(treeDataPDF)
		set_dados(dados.current.content[order],)
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_name(aux2)

				let aux_doc = treeDataPDF
				if (treeDataPDF[order] === undefined)
					treeDataPDF[order] = []
				if (treeDataPDF[order][langid] === undefined)
					treeDataPDF[order][langid] = []
				let i = treeDataPDF[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDF(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf(files_aux)
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		for await (let element of files) {
			aux.push(element)

			await uploadFile(element, order, type, langid, lang)
		}
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'maintenance')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/maintenance/');

		let res = await reqFILE(`${api_crud_base}/multimedia/file`, formData)

		var today_file = new Date()
		let i = Date.now()

		if (dados.current.info.file === undefined) {
			dados.current.info.file = {}
		}
		if (!Array.isArray(dados.current.info.file[type])) {
			dados.current.info.file[type] = []
		}

		if (type === 'editable') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'pdf') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'file_image') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}

		await reqPUT(api_crud_route, dados.current)

		return true

	}

	const handle_change_tree_image = (tD, order, langid) => {

		treeDataImage[order][langid] = tD

		let aux = []
		treeDataImage[order][langid].forEach((el) => {
			dados.current.info.file.image.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.image = aux)
		setTreeDataImage(treeDataImage)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_image = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataImage[order][langid].filter(v => v.id !== id)
					treeDataImage[order][langid] = treeAux
					setTreeDataImage(treeDataImage)

					let aux = []
					dados.current.info.file.image.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.image = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_image = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataImage[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.image.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataImage(treeDataImage)
		set_dados(dados.current.info,)
	}

	const onChangeHandlerFilesFileImage = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_image_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_image_name(aux2)

				let aux_doc = treeDataImage
				if (treeDataImage[order] === undefined)
					treeDataImage[order] = []
				if (treeDataImage[order][langid] === undefined)
					treeDataImage[order][langid] = []
				let i = treeDataImage[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataImage(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_image(files_aux)
	}

	const getRepairTypeLabel = (type) => {
		if (type === "13") return "Curativa";
		if (type === "12") return "Preventiva";
		return type || '—';
	};

	const getLangValue = (arr) => {
		if (!Array.isArray(arr) || arr.length === 0) return '—';
		return arr[0]?.[lang] || '—';
	};

	const getPriorityLabel = (id) => {
		const match = priority.current.find((p) => p.id === id);
		return match?.label || '—';
	};

	const handleAddMaintenanceInt = async () => {
		if (!selectedEquipment || !selectedEquipment.id) {
			console.warn("selectedEquipment not ready yet");
			alert("Please wait while equipment data loads.");
			return;
		}

		let aux = {
			...(isEditing && editItemId ? { id: editItemId } : {}),

			info: {
				type: 'intervention',
				active: false,
				atividade: dados.current.atividade || [],
				avaiable: false,
				companycode: '2024000',
				equipment: {
					id: selectedEquipment.id,
					name: selectedEquipment.name,
					cod: selectedEquipment.cod,
					brand: selectedEquipment.brand,
					model: selectedEquipment.model,
					serie: selectedEquipment.serie,
					local: selectedEquipment.local,
				},
				action: dados.current.info.action || [],
				utilities: dados.current.info.utilities || [],
				uniqid: uid,

				observacoes: dados.current.observacoes || [],
				service: dados.current.info.service || [],
				settings: dados.current.info.settings || {},
				tipo_intervencao: dados.current.tipo_intervencao || [],
			},
		};

		try {
			let res;

			if (isEditing) {
				res = await reqPUT(`${api_crud_base}/intranet/maintenance`, aux);
			} else {
				res = await reqPOST(`${api_crud_base}/intranet/maintenance`, aux);
			}

			if (res.status === 200) {
				get_info(aux.info.equipment.id);
				setRefresh(prev => prev + 1);
				setIsEditing(false);
				setEditItemId(null);
				setModal(false);
			} else {
				console.error("API Error", res);
			}
		} catch (err) {
			console.error("Error saving maintenance order:", err);
		}

		resetModalFields();
	};

	const handleEditMaintenanceInt = (item) => {
		setIsEditing(true);
		setEditItemId(item.id);
		setSelectedEquipment(item.info.equipment);

		dados.current = {
			...item,
			info: {
				...item.info,
				settings: { ...item.info.settings },
			},
			atividade: item.info.atividade || [],
			tipo_intervencao: item.info.tipo_intervencao || [],
		};

		const repairType = item.info.settings?.repair_type;
		if (repairType === '13') {
			setManutencao(true);
		} else if (repairType === '12') {
			setManutencao(false);
		}

		setModal(true);
	};

	const handleRemoveMaintenanceInt = async (intId) => {
		try {

			await Swal.fire({
				title: language[lang].delete_title,
				text: language[lang].delete_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].delete_confirm,
				cancelButtonText: language[lang].delete_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {

						const res = await reqDELETE(`${api_crud_base}/intranet/maintenance`, intId);

						if (res?.status === 200) {

							setModal(false);
							setIsEditing(false);
							setEditItemId(null);

							get_info(selectedEquipment);
							setRefresh(prev => prev + 1);

						} else {
							console.error("API Error while deleting", res);
						}
					}
				})

		} catch (err) {
			console.error("Error removing maintenance order:", err);
		}
	};

	const resetModalFields = () => {
		dados.current = {
			info: {
				type: 'intervention',
				active: false,
				avaiable: false,
				companycode: '2024000',
				equipment: {
					id: '',
					name: '',
					cod: '',
					brand: '',
					model: '',
					serie: '',
					local: '',
				},
				action: [],
				utilities: [],
				service: [],
				settings: {
					repair_type: '',
					data_inicio: '',
					deadline: '',
					det_date: '',
					activity_number: '',
					activity: '',
					procedure: '',
					element: '',
					periodicity: '',
				},
			}
		};

	};

	useEffect(() => {
		if (modal) {
			if (!isEditing) {
				resetModalFields();
			}
			setUpdate((prev) => prev + 1);
		}

		if (
			dados?.current?.info?.external_intervention !== undefined &&
			dados?.current?.info?.external_intervention !== null
		) {
			setExternalIntervention(dados.current.info.external_intervention);
		}

		if (selectedEquipment) {
			console.log("✅ selectedEquipment não selecionado ", selectedEquipment);
		}

	}, [modal, dados, selectedEquipment, isEditing]);

	return isloading ?
		<Loader />
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<div className="container">
						<h2 className="dash-title">{language[lang].component}</h2>
						<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
					</div>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className='card'>
									<div className="card-header border-0 d-flex justify-content-sm-between">
										{/* 
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
										</div>
										*/}
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<li key={k_lang} className="nav-item d-none">
																	<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
																</li>
															)
														})
														:
														null
												}
											</ul>
										</div>
									</div>

									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
														content_language.length > 0 ?
															content_language.map((el_lang, k_lang) => {
																return (
																	<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">

																		<div className="row mb-4 ">
																			<div className="col-md-8">
																				{selectedEquipment && (
																					<div className="border rounded p-3 bg-light">
																						<h6 className="fw-bold mb-4">🔍 {language[lang].field_details}</h6>
																						<p><strong>{language[lang].field_id}:</strong> {selectedEquipment.id}</p>
																						<p><strong>{language[lang].field_label}:</strong> {selectedEquipment.name}</p>
																						<p><strong>{language[lang].field_cod}:</strong> {selectedEquipment.cod}</p>
																						<p><strong>{language[lang].field_brand}:</strong> {selectedEquipment.brand}</p>
																						<p><strong>{language[lang].field_model}:</strong> {selectedEquipment.model}</p>
																						<p><strong>{language[lang].field_serie}:</strong> {selectedEquipment.serie}</p>
																						<p><strong>{language[lang].field_local}:</strong> {selectedEquipment.local}</p>
																					</div>
																				)}
																			</div>
																		</div>
																		<div className="row mb-3">
																			<div className="card-title m-0 mt-4 d-flex justify-content-between align-items-center">
																				<div></div>

																				{/* Add Button */}
																				<div>
																					<label>&nbsp;</label>
																					<button
																						type="button"
																						className='btn rounded-pill btn-sm py-1 px-4 btn-outline-secondary'
																						onClick={() => setModal(true)}
																					>
																						{language[lang].add_new}
																					</button>
																				</div>
																			</div>
																		</div>

																		{/* Table */}
																		<div className="row mb-4">
																			<div className='col-12 col-md-4'></div>
																			<div className='col-12 col-md-8 d-flex'>
																				{/* Year Filter */}																				
																				{
																				years_actives.current !== undefined && years_actives.current !== null ?
																					<div className='col me-3'>
																						<label>
																							{language[lang].ano}
																						</label>
																						<select
																							className="form-select form-control mb-4 mb-lg-0 rounded-0"
																							value={filterYear}
																							onChange={(e) => setFilterYear(e.target.value)}
																						>
																							<option value="">{language[lang].field_choose}</option>
																							{years_actives.current.map((year) => (
																								<option key={year} value={year}>{year}</option>
																							))}
																						</select>
																					</div>
																				:
																					null
																				}

																				{/* Month Filter */}
																				<div className='col me-3'>
																					<label>
																						{language[lang].mes}
																					</label>
																					<select
																						className="form-select form-control mb-4 mb-lg-0 rounded-0"
																						value={filterMonth}
																						onChange={(e) => setFilterMonth(e.target.value)}
																					>
																						<option value="">{language[lang].field_choose}</option>
																						{MONTH_NAMES.map((monthName, i) => (
																							<option key={i + 1} value={i + 1}>{monthName}</option>
																						))}
																					</select>
																				</div>

																				{/* Clear Month Button */}
																				<div className='col'>
																					<label>&nbsp;</label>
																					<button
																						type="button"
                                        													className='btn btn-primary w-100'
																						onClick={() => {
																							setFilterMonth('');
																							setFilterYear(new Date().getFullYear().toString());
																						}}

																					>
																						{language[lang].field_clean}
																					</button>
																				</div>
																			</div>
																		</div>
																		
																		<div className="row mb-4">
																			{
																				maintenance_intervention.current !== null &&
																				selectedEquipment?.id &&
																				maintenance_intervention.current.some(int =>
																					parseInt(int.info?.equipment?.id) === parseInt(selectedEquipment.id)
																				) && (
																					<div className={"div-table"}>
																						<div className='table-body table-responsive'>
																							<table className="table table-hover table-bordered align-middle">
																								<thead className="text-center align-middle">
																									<tr>
																										<th className='p-3'>{language[lang].int_cod}</th>
																										<th className='p-3'>{language[lang].int_data}</th>
																										<th className='p-3'>{language[lang].int_prioridade}</th>
																										<th className='p-3'>{language[lang].tipo_intervencao}</th>
																										<th className='p-3'>{language[lang].atividade}</th>
																										{/*<th className='p-3'>{language[lang].tipo_manutencao}</th>*/}
																										<th className='p-3'></th>
																									</tr>
																								</thead>
																								<tbody>
																									{maintenance_intervention.current
																										.filter(int => {
																											const equipmentId = int.info?.equipment?.id;
																											const selectedId = selectedEquipment?.id;
																											if (!equipmentId || !selectedId) return false;

																											if (parseInt(equipmentId) !== parseInt(selectedId)) return false;

																											const startDateStr = int.info?.settings?.data_intervencao;
																											if (!startDateStr) return false;

																											const date = new Date(startDateStr);
																											if (isNaN(date)) return false;

																											if (filterYear && date.getFullYear() !== parseInt(filterYear)) return false;
																											if (filterMonth && (date.getMonth() + 1) !== parseInt(filterMonth)) return false;

																											return true;
																										})
																										.map((item) => (
																											<tr key={item.id} style={rowStyle}>
																												<td className='text-center'>{item.id || '—'}</td>
																												<td className='text-center'>
																													{item.info.settings?.data_intervencao
																														? item.info.settings.data_intervencao
																														: 'Sem data'}
																												</td>
																												<td className='text-center'>
																													{getPriorityLabel(item.info.settings?.priority)}
																												</td>
																												<td className='text-center'>
																													{getLangValue(item.info.atividade)}
																												</td>
																												<td className='text-center'>
																													{getLangValue(item.info.tipo_intervencao)}
																												</td>
																												{/*
																												<td>
																													{getRepairTypeLabel(item.info.settings?.repair_type)}
																												</td>
																												*/}
																												<td className='text-center'>
																													<span>
																														<button type="button" className='me-3' onClick={() => handleEditMaintenanceInt(item)}>
																															<i className="bi bi-pencil"></i>
																														</button>
																													</span>
																													<span>
																														<button type="button" onClick={() => handleRemoveMaintenanceInt(item)}>
																															<i className="bi bi-trash"></i>
																														</button>
																													</span>
																												</td>
																											</tr>
																										))}
																								</tbody>
																							</table>
																						</div>
																					</div>
																				)
																			}
																		</div>

																		{modal && (
																			<div
																				className="modal fade show d-block"
																				tabIndex="-1"
																				role="dialog"
																				style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
																			>
																				<div
																					className="modal-dialog modal-dialog-centered"
																					role="document"
																					style={{ marginLeft: '25%', maxWidth: '90%', width: '1100px', borderRadius: '8px', marginTop: '4%' }}
																				>
																					<div
																						className="modal-content rounded-4 shadow overflow-hidden"
																						style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}
																					>
																						{/* HEADER */}
																						<div className="modal-header">
																							<h5 className="modal-title">{language[lang].add_new}</h5>
																							<button type="button" className="btn-close" onClick={() => setModal(false)} />
																						</div>

																						{/* BODY */}
																						<div className="modal-body px-4" style={{ flex: 1, overflowY: 'auto' }}>
																							<div className="row mb-4">
																								<div className="col-4">
																									<label className="fs-6 fw-bold mb-2">{language[lang].field_data_intervencao}</label>
																									<input
																										type="date"
																										name="data_intervencao"
																										value={dados.current?.info?.settings?.data_intervencao ?? ''}
																										onChange={(e) => change_active_settings(e)}
																										className="form-control mb-4 rounded-0"
																										required
																									/>
																								</div>
																								<div className="col-4">
																									<label className="fs-6 fw-bold mb-2">{language[lang].prioridade}</label>
																									<select
																										name="priority"
																										className="form-select form-control mb-4 rounded-0"
																										onChange={(e) => change_active_settings(e)}
																										value={dados.current?.info?.settings?.priority ?? ''}
																									>
																										<option value="">{language[lang].field_choose}</option>
																										{priority.current?.map((el, k) => (
																											<option key={k} value={el.id}>
																												{el.label}
																											</option>
																										))}
																									</select>
																								</div>
																							</div>

																							<div className="row mb-4">
																								<div className="col-6">
																									<label className="fs-6 fw-bold mb-2">
																										{language[lang].tipo_intervencao} {k_lang > 0 ? `(${el_lang.code})` : ''}
																									</label>
																									<textarea
																										rows="4"
																										name="tipo_intervencao"
																										data-langid={el_lang.id}
																										data-lang={el_lang.code}
																										defaultValue={translate(dados.current?.info?.tipo_intervencao, el_lang.code)}
																										onChange={handle_change_info_translate}
																										className="form-control rounded-0"
																									/>
																								</div>

																								<div className="col-6">
																									<label className="fs-6 fw-bold mb-2">
																										{language[lang].atividade} {k_lang > 0 ? `(${el_lang.code})` : ''}
																									</label>
																									<textarea
																										rows="4"
																										name="atividade"
																										data-langid={el_lang.id}
																										data-lang={el_lang.code}
																										defaultValue={translate(dados.current?.info?.atividade, el_lang.code)}
																										onChange={handle_change_info_translate}
																										className="form-control rounded-0"
																									/>
																								</div>
																							</div>

																							<div>
																								<h3 className="fw-bolder m-0">{language[lang].tecnicos_tempos}</h3>
																								{/* Colaboradores e tempos */}
																								<div className="card-body border-top p-4">
																									<div className='row'>
																										<div className='col-12 text-end mb-3'>
																											<button type="button" className='btn btn-sm btn-secondary rounded-0' onClick={(() => add_action)()}>{language[lang].add_colab}</button>
																										</div>
																									</div>

																									{Array.isArray(dados.current?.info?.action) ?
																										dados.current?.info?.action.map((a_el, a_key) => (
																											<div key={a_key} className='row mb-4'>
																												<div className='col-12'>
																													<div className='row mb-4'>
																														<div className="col-3 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].tecnicos}</label>
																															<select
																																name="responsavel"
																																data-order={a_key}
																																className="form-select form-control mb-4 mb-lg-0 rounded-0"
																																onChange={change_action}
																																value={a_el?.responsavel?.id !== undefined && a_el?.responsavel?.id !== null ? a_el?.responsavel?.id : ''}
																															>
																																<option value="">{language[lang].field_choose}</option>
																																{
																																	entities_list.current !== undefined && entities_list.current !== null ?
																																		entities_list.current.map((el_dt, k_dt) => (
																																			<option key={k_dt} value={el_dt.id}>
																																				{el_dt.label}
																																			</option>
																																		)) :
																																		null
																																}
																															</select>
																														</div>

																														<div className="col-3 mb-3">
																															<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_data_inicio}</label>
																															<input
																																type="date"
																																name="data_inicio"
																																data-order={a_key}
																																defaultValue={a_el.data_inicio}
																																onChange={(e) => change_action(e)}
																																className="form-control mb-4 rounded-0"
																															/>
																														</div>

																														<div className="col-3 mb-3">
																															<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_deadline}</label>
																															<input
																																type="date"
																																name="deadline"
																																data-order={a_key}
																																defaultValue={a_el.deadline}
																																onChange={(e) => change_action(e)}
																																className="form-control mb-4 rounded-0"
																															/>
																														</div>
																													</div>

																													<div className='row mb-4'>
																														<div className="col-3 mb-3">
																															<label className={"fs-6 fw-bold mb-2"}>{language[lang].tempo}</label>
																															<div className="form-control mb-4 rounded-0 bg-light">
																																{
																																	(() => {
																																		const start = new Date(a_el.data_inicio);
																																		const end = new Date(a_el.deadline);
																																		if (!isNaN(start) && !isNaN(end)) {
																																			const diffTime = end.getTime() - start.getTime();
																																			const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
																																			return `${diffDays} ${language[lang].days}`;
																																		}
																																		return language[lang].invalid_date;
																																	})()
																																}
																															</div>
																														</div>
																														<div className="col-3 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_cost}</label>
																															<div className="input-group">
																																<input
																																	type="number"
																																	name="cost"
																																	data-order={a_key}
																																	className="form-control rounded-0 text-end"
																																	placeholder={language[lang].field_cost_placeholder}
																																	value={a_el?.cost ?? ''}
																																	onChange={change_action}
																																/>
																																<span className="input-group-text rounded-0">&euro;</span>
																															</div>
																														</div>
																													</div>
																												</div>
																												<div className="col-3 mb-4 d-none">
																													<button
																														type="button"
																														className="btn btn-sm btn-outline-danger rounded-0"
																														onClick={() => {
																															dados.current?.info?.action.splice(a_key, 1)
																															set_dados({ ...maintenance_intervention?.current?.[0] })
																															setRefresh(r => r + 1)
																														}}
																													>
																														✖️ {language[lang].remove ?? ''}
																													</button>
																												</div>
																											</div>
																										)) : null
																									}

																									{
																										Array.isArray(dados.current?.info?.action) && dados.current?.info?.action.length > 0 ? (
																											<div className="row justify-content-end">
																												<div className="col-3">
																													<label className="fs-6 fw-bold mb-2 text-end d-block">{language[lang].total_tempo}</label>
																													<div className="form-control rounded-0 bg-light text-end">
																														{
																															(() => {
																																const total = dados.current?.info?.action.reduce((sum, el) => {
																																	const start = new Date(el.data_inicio);
																																	const end = new Date(el.deadline);
																																	if (!isNaN(start) && !isNaN(end)) {
																																		const diffTime = end.getTime() - start.getTime();
																																		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
																																		return sum + diffDays;
																																	}
																																	return sum;
																																}, 0);
																																return `${total} ${language[lang].days}`;
																															})()
																														}
																													</div>
																												</div>
																											</div>

																										) : null
																									}
																								</div>
																							</div>

																							<div>
																								{/* Peças Utilizadas */}
																								<div className="card-body border-top p-4">
																									<div className="row">
																										<div className="col-12 text-end mb-3">
																											<button
																												type="button"
																												className="btn btn-sm btn-secondary rounded-0"
																												onClick={add_utilities}
																											>
																												{language[lang].add_peca}
																											</button>
																										</div>
																									</div>

																									{Array.isArray(dados.current?.info?.utilities) &&
																										dados.current?.info?.utilities.map((a_el, a_key) => (
																											<div key={a_key} className="row mb-4">
																												<div className="col-12">
																													<div className="row mb-4">
																														<div className="col-3 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_code}</label>
																															<div className="input-group">
																																<input
																																	type="text"
																																	name="code"
																																	data-order={a_key}
																																	className="form-control rounded-0"
																																	placeholder={language[lang].field_code_placeholder}
																																	value={a_el?.code ?? ''}
																																	onChange={change_utilities}
																																/>
																															</div>
																														</div>

																														<div className="col-6 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_ident}</label>
																															<input
																																type="text"
																																name="description"
																																data-order={a_key}
																																className="form-control rounded-0"
																																placeholder={language[lang].field_ident_placeholder}
																																value={a_el?.description ?? ''}
																																onChange={change_utilities}
																															/>
																														</div>

																														<div className="col-3 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_quantity ?? 'Quantity'}</label>
																															<input
																																type="number"
																																name="quantity"
																																data-order={a_key}
																																className="form-control rounded-0"
																																placeholder={language[lang].field_quantity_placeholder}
																																min={1}
																																value={a_el?.quantity ?? 1}
																																onChange={change_utilities}
																															/>
																														</div>
																													</div>

																													<div className="row align-items-end">
																														<div className="col-3 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_provider}</label>
																															<select
																																name="fornecedor"
																																data-order={a_key}
																																className="form-select form-control mb-4 mb-lg-0 rounded-0"
																																onChange={change_utilities}
																																placeholder={language[lang].field_provider_placeholder}
																																value={a_el?.fornecedor?.id ?? ''}
																															>
																																<option value="">{language[lang].field_choose}</option>
																																{entities_list_external.current?.map((el_dt, k_dt) => (
																																	<option
																																		key={k_dt}
																																		value={el_dt.id}
																																		data-name={el_dt.name}
																																	>
																																		{el_dt.name}
																																	</option>
																																))}
																															</select>
																														</div>

																														<div className="col-3 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_cost}</label>
																															<div className="input-group">
																																<input
																																	type="number"
																																	name="cost"
																																	data-order={a_key}
																																	className="form-control rounded-0 text-end"
																																	placeholder={language[lang].field_cost_placeholder}
																																	value={a_el?.cost ?? ''}
																																	onChange={change_utilities}
																																/>
																																<span className="input-group-text rounded-0">&euro;</span>
																															</div>
																														</div>
																													</div>
																													<div className="col-3 mb-4 d-none">
																														<button
																															type="button"
																															className="btn btn-sm btn-outline-danger rounded-0"
																															onClick={() => {
																																dados.current?.info?.utilities.splice(a_key, 1)
																																set_dados({ ...maintenance_intervention?.current?.[0] })
																																setRefresh(r => r + 1)
																															}}
																														>
																															✖️ {language[lang].remove ?? ''}
																														</button>
																													</div>
																												</div>
																											</div>
																										))}
																								</div>
																							</div>

																							<div>
																								{/* Serviços Externos */}
																								<div className="card-body border-top p-4">
																									<div className="row">
																										<div className="col-12 text-end mb-3">
																											<button
																												type="button"
																												className="btn btn-sm btn-secondary rounded-0"
																												onClick={add_service}
																											>
																												{language[lang].add_service}
																											</button>
																										</div>
																									</div>

																									{Array.isArray(dados.current?.info?.service) &&
																										dados.current?.info?.service.map((a_el, a_key) => (
																											<div key={a_key} className="row mb-4">
																												<div className="col-12">
																													<div className="row mb-4">
																														<div className="col-3 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_service}</label>
																															<div className="input-group">
																																<input
																																	type="text"
																																	name="service"
																																	data-order={a_key}
																																	className="form-control rounded-0"
																																	placeholder={language[lang].field_service_placeholder}
																																	value={a_el?.service ?? ''}
																																	onChange={change_service}
																																/>
																															</div>
																														</div>

																														<div className="col-6 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_description}</label>
																															<input
																																type="text"
																																name="description"
																																data-order={a_key}
																																className="form-control rounded-0"
																																placeholder={language[lang].field_description_placeholder}
																																value={a_el?.description ?? ''}
																																onChange={change_service}
																															/>
																														</div>
																													</div>
																													<div className="row mb-4">
																														<div className="col-3 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_provider}</label>
																															<select
																																name="fornecedor"
																																data-order={a_key}
																																className="form-select form-control mb-4 mb-lg-0 rounded-0"
																																onChange={change_service}
																																value={
																																	a_el?.fornecedor?.id !== undefined && a_el?.fornecedor?.id !== null
																																		? a_el?.fornecedor?.id
																																		: ''
																																}
																															>
																																<option value="">{language[lang].field_choose}</option>
																																{entities_list_external.current?.map((el_dt, k_dt) => (
																																	<option
																																		key={k_dt}
																																		value={el_dt.id}
																																		data-name={el_dt.name}
																																	>
																																		{el_dt.name}
																																	</option>
																																))}
																															</select>
																														</div>
																														<div className="col-3 mb-3">
																															<label className="fs-6 fw-bold mb-2">{language[lang].field_cost}</label>
																															<div className="input-group">
																																<input
																																	type="number"
																																	name="cost"
																																	data-order={a_key}
																																	className="form-control rounded-0 text-end"
																																	placeholder={language[lang].field_cost_placeholder}
																																	value={a_el?.cost ?? ''}
																																	onChange={change_service}
																																/>
																																<span className="input-group-text rounded-0">&euro;</span>
																															</div>
																														</div>
																													</div>
																													<div className="col-3 mb-4 d-none">
																														<button
																															type="button"
																															className="btn btn-sm btn-outline-danger rounded-0"
																															onClick={() => {
																																dados.current?.info?.service.splice(a_key, 1)
																																set_dados({ ...maintenance_intervention?.current?.[0] })
																																setRefresh(r => r + 1)
																															}}
																														>
																															✖️ {language[lang].remove ?? ''}
																														</button>
																													</div>
																												</div>
																											</div>
																										))}
																								</div>
																							</div>

																							<div className="row mb-4">
																								<div className="col-12">
																									<label className="fs-6 fw-bold mb-2">
																										{language[lang].observacoes} {k_lang > 0 ? `(${el_lang.code})` : ''}
																									</label>
																									<textarea
																										rows="4"
																										name="observacoes"
																										data-langid={el_lang.id}
																										data-lang={el_lang.code}
																										defaultValue={translate(dados.current?.info?.observacoes, el_lang.code)}
																										onChange={handle_change_info_translate}
																										className="form-control rounded-0"
																									/>
																								</div>
																							</div>
																						</div>

																						{/* FOOTER */}
																						<div className="modal-footer">
																							<button type="button" className="btn btn-default" onClick={() => { setModal(false); }}>
																								{language[lang].close}
																							</button>
																							<button
																								type="button"
																								onClick={handleAddMaintenanceInt}
																								className="btn btn-default"
																							>
																								{language[lang].add}
																							</button>
																						</div>
																					</div>
																				</div>
																			</div>
																		)}

																	</div>
																)
															})
															:
															null
													}
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								{/*
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
								*/}
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
